
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vitamin-checklist",
      function () {
        return require("private-next-pages/vitamin-checklist/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vitamin-checklist"])
      });
    }
  